import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import './index.css'
import Header from '../Header'
import Loading from '../LoadingComponent'
import { Button } from '@material-ui/core'
import COLORS from '../../colors'
import { AuthContext } from '../../App.js'
import { getHostName } from '../../base.js'
import { isMobile } from 'react-device-detect'
import { useSwipeable } from 'react-swipeable'

const UserManual = ({cid}) => {

    const { resetPN, setPrevPage, setPageNumber, signOut } = useContext(AuthContext)
    const [ isLoading, setIsLoading ] = useState(true)
    const params = useParams()
    const navigate = useNavigate()
    // setup ref for your usage
    const myRef = useRef();
    const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe() })

    const handleLeftSwipe = () => {
            resetPN()
            setTimeout(() => { 
                  navigate(`/kekspos/${params.tid}`)
            },0)
    }

    const refPassthrough = (el) => {
            // call useSwipeable ref prop with el
            handlers.ref(el)
            // set myRef el so you can access it yourself
            myRef.current = el
    }

    useEffect(() => {
        setTimeout(() => setIsLoading(false), 1000) 
        setPrevPage({prevPageNum:15})
        window.addEventListener('popstate', onBackButtonEvent)
      
        return () => {
                window.removeEventListener('popstate', onBackButtonEvent);
        }
      }, [])

    const onBackButtonEvent = (e) => {
            e.preventDefault()
            resetPN()
            navigate(`/kekspos/${params.tid}`)	 	 
    }
    
    useEffect(() => 
    {   
        const handleReload = async (e) => 
        {
            e.preventDefault()
            signOut(cid)
            setTimeout(() => window.location.assign(`/kekspos`, 0));
            window.removeEventListener('beforeunload', handleReload)   
            return false
        }

        window.addEventListener("beforeunload", handleReload)
         
        return () => 
        {    
              window.removeEventListener('beforeunload', handleReload) 
        }
  
  	  }, [])
    
  if(!isLoading){
  return (
    <div className="user-manual" {...handlers} ref={refPassthrough}>
			    <Header pageNumber={15}/>
          <div className="user-manual-main">
			<div className="user-manual-body" style={{padding:!isMobile?'2rem':'1rem'}}>
                <div className="user-manual-title" >Uvjeti korištenja mobilne aplikacije i web stranice KEKS POS</div>
                <div className="user-manual-title-2">Uvod</div>
                <div>
                  Pozdrav, drago nam je da te zanima Keks Pay, naša nova mobilna aplikacija. U tekstu ispod smo pokušali objasniti sve detalje o našoj aplikaciji, i to jednostavnim, razumljivim jezikom. Više o tome što je Keks Pay i kako ga možeš koristiti pronađi u nastavku.
                  Kako bi mogla/mogao koristiti Keks Pay moraš imati otvoren transakcijski račun u bilo kojoj banci u Republici Hrvatskoj te sve tehničke preduvjete navedene u poglavlju 6.
                </div>
                <div className="user-manual-title-2">Značenje riječi</div>
                <div>U daljnjem tekstu ovih Općih uvjeta možemo koristiti riječi:</div>
                <ul className="user-manual-list">
                    <li>"Opći uvjeti" - za ove Opće uvjete korištenja aplikacije Keks Pay</li>
                    <li>"Ti" ,"Tvoj", "Tebi" ili "Tebe" - kako bismo označili da se radi o tebi kao korisniku aplikacije Keks Pay</li>
                    <li>„Erste Banka“, „Banka“,"Mi", "Nas"</li> 
                </ul>
                <div>
                    Ako prihvatiš ove Opće uvjete, pristaješ na to da Te kontaktiramo tj. da komuniciramo s tobom. Za tu ćemo komunikaciju koristiti Keks Pay i sve druge kanale koji su nam poznati i dostupni.
                    Svrha te komunikacije su primjerice:
                </div>
                <ul className="user-manual-list">
                    <li>obavijesti o porukama koje su Ti poslali drugi korisnici Keks Pay-a</li>
                    <li>obavijesti o Keks Pay transakcijama</li>
                    <li>podsjetnici o vremenu isteka Keks Pay transakcija</li>
                    <li>obavijesti o plaćanjima kod Trgovaca</li>
                    <li>obavijesti o eventualnoj nedostupnosti i slično</li>
                </ul>
                <div>
                    Elektronički oblici komunikacije su : SMS, MMS, push notifikacije, ekrani u Keks Pay-u, email pošta te svi ostali oblici komunikacije dostupni putem Keks Pay-a ili korištenjem kontakt podataka koje nam dostaviš putem aplikacije (broj telefona, e-mail adresa i slično)
                    Ako prihvatiš ove Opće uvjete, pristaješ na to da Te kontaktiramo tj. da komuniciramo s tobom. Za tu ćemo komunikaciju koristiti Keks Pay i sve druge kanale koji su nam poznati i dostupni.
                    Svrha te komunikacije su primjerice:
                </div>
                <ul className="user-manual-list">
                    <li>obavijesti o porukama koje su Ti poslali drugi korisnici Keks Pay-a</li>
                    <li>obavijesti o Keks Pay transakcijama</li>
                    <li>podsjetnici o vremenu isteka Keks Pay transakcija</li>
                    <li>obavijesti o plaćanjima kod Trgovaca</li>
                    <li>obavijesti o eventualnoj nedostupnosti i slično</li>
                </ul>
                <div>
                    Elektronički oblici komunikacije su : SMS, MMS, push notifikacije, ekrani u Keks Pay-u, email pošta te svi ostali oblici komunikacije dostupni putem Keks Pay-a ili korištenjem kontakt podataka koje nam dostaviš putem aplikacije (broj telefona, e-mail adresa i slično)
                </div>
			</div>
            <Link to={`/kekspos/${params.tid}`} className="user-manual-btn">
                <Button size="large" 
		                    variant="contained"
		                    style={{ width:!isMobile?'25rem':'90%',
			  	                        height: '3rem',
				                          justifyContent:'center',
				                          color:"#fff", 
				                          fontWeight: 'bold', 
				                          backgroundColor: COLORS.blue, 
				                          marginTop:'0.5rem', 
				                          textTransform: 'none',
				                          "&:hover": {
					                            backgroundColor:COLORS.blue
			  	                        }
			          	        }}    
	 	                    onClick={() => resetPN()}
	              >OK, ZATVORI</Button>
            </Link>
          </div>
    </div>
  )
  }else{
    return(
      <div>
          <Loading/>
      </div>
    )
  }
}

export default UserManual
